import styled from "styled-components";

export const FloatingDropdownWrapper = styled.ul`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  min-width: 170px;
  margin: 0;
  padding: 6px 0;
  list-style-type: none;
  box-shadow: 1px 1px 6px 0px rgba(64, 26, 15, 0.25);
  border: 1px solid #eee;
  border-radius: 12px;
  background-color: white;
`;

type FloatingDropdownItemWrapperProps = {
  isLast?: boolean;
  isDestructiveAction?: boolean;
  isHighlighted?: boolean;
};

export const FloatingDropdownItemWrapper = styled.li<FloatingDropdownItemWrapperProps>`
  background-color: ${(props) => (props.isHighlighted ? ` #eee` : "white")};
  border-bottom: 1px solid #f1f1f1;
  ${(props) => props.isHighlighted && `border-bottom: none;`}
  padding: 0 10px;
  position: relative;
  :last-child {
    border-bottom: none;
  }

  button {
    width: 100%;
    border: 0;
    background: transparent;
    border-radius: 8px;
    padding: 9px 10px;
    color: ${(props) => (props.isDestructiveAction ? "red" : "black")};
    font-family: Montserrat;
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    letter-spacing: 0em;
    text-align: left;

    &:hover {
      background: #f6f7f9;
    }
  }
`;
